goog.provide("shadow.js.shim.module$src$svg$objects$database_svg$default");
shadow.js.shim.module$src$svg$objects$database_svg$default = shadow.js.shim.module$src$svg$objects$database_svg.default;
